import { ChangeDetectionStrategy, Component, inject, model, ViewEncapsulation } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LauncherModulesFacade } from '@layout/launcher/facades/launcher-modules.facade';
import { SpinnerComponent } from '@kaseya-design-components';
import { LauncherItemComponent } from '@layout/launcher/components/launcher-item/launcher-item.component';
import { getHeaderHeight } from '@shared/utils/header-height';

@Component({
  selector: 'itc-launcher-panel',
  templateUrl: 'launcher-panel.component.html',
  styleUrl: 'launcher-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [TranslatePipe, SpinnerComponent, LauncherItemComponent],
})
export class LauncherPanelComponent {
  private readonly launcherModulesFacade = inject(LauncherModulesFacade);

  readonly isWidgetVisible = model<boolean>();
  readonly modules = this.launcherModulesFacade.modules;
  readonly loading = this.launcherModulesFacade.loading;
  readonly headerHeight = getHeaderHeight();
}
